import {
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_BEGIN,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_FAILURE,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
export function updateCollectionForSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_BEGIN,
    });

    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_SUCCESS,
            data: res,
          });
          toast.success('Collection Updated Successfully !');

          resolve(res);
        },
        (err) => {
          toast.error(`Failed: to Update Collection`);
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionForSalesforceError() {
  return {
    type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_BEGIN:
      return {
        ...state,
        updateCollectionForSalesforcePending: true,
        updateCollectionForSalesforceError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_SUCCESS:
      return {
        ...state,
        updateCollectionForSalesforcePending: false,
        updateCollectionForSalesforceError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_FAILURE:
      return {
        ...state,
        updateCollectionForSalesforcePending: false,
        updateCollectionForSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionForSalesforceError: null,
      };

    default:
      return state;
  }
}
